export default __webpack_public_path__ + "static/media/ResumeMehar.2c901754.pdf";